import { Button } from '@/components/Elements';
import user from '@/assets/anderson.png';
import loc from '@/assets/location.png';
import agency from '@/assets/agncy.png';
import { Link } from '@mui/material';
import { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import close from '@/assets/close-circle.svg';
import { useLawyersDeal } from '@/api/lawyerDeal/lawyerDeal';
import { finalizeLawyer, finalizeLawyerRequest } from '@/api/lawyerDeal/finalizeLawyer';
import DigitalSignature from '@/features/user/routes/Contract/DigitalSignature';
import digitalSignature from '@/assets/digitalSignature.png';
import { useNotificationStore } from '@/stores/notifications';
import { createChat } from '@/api/Chat/createChat';
import { useNavigate } from 'react-router-dom';
import { useGetAcceptedRequestLawyer, useGetPropertyLawyerReq } from './lawyerList';

const LawyerAllRequests = () => {
  const navigate = useNavigate();
  // const { data, isLoading, isFetching, refetch } = useLawyersDeal({ page: '1' });
  const { data, isLoading, isFetching, refetch } = useGetPropertyLawyerReq();
  console.log(data);

  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [id, setId] = useState<string>();
  const [link, setLink] = useState<string>();
  const [contractId, setContractId] = useState<number>();
  const [signature, setSignature] = useState<any>();
  const [signErr, setSignErr] = useState<boolean>(false);
  const [price, setPrice] = useState<string>();

  const handleModal = (contract_id: number, file: number) => {
    setId(id);
    onOpenModal();
    setLink(file);
    setContractId(contract_id);
  };

  console.log(data);

  const handleSignature = async () => {
    if (!signature) {
      return setSignErr(true);
    }
    const payload: any = {
      customer_signature: signature,
      contract_id: contractId,
    };
    const res = await finalizeLawyerRequest(payload);
    if (res) {
      useNotificationStore.getState().addNotification({
        type: 'success',
        title: 'Succes',
        message: `Lawyer finalized successfully!`,
      });
      onCloseModal();
      refetch();
    }
  };
  useEffect(() => {
    if (signature) {
      setSignErr(false);
    }
  }, [signature]);

  const handleChat = async (lawyerId: number) => {
    try {
      const res: any = await createChat(lawyerId);
      navigate(`/user/chat?id=${lawyerId}&sid=${res?.twilio_channel_sid}`);
    } catch (err) {
      console.log(err);
    }
  };

  // const filteredData = data?.data?.filter((item: any) => item?.req_status === 'accepted' || item?.req_status === 'Already Finalized');

  return (
    <div className="agency-card-row lawyer-rq accept">
      <div className="row">
        {data?.data && data?.data?.length > 0 ? (
          data?.data?.map((val: any) => {
            let buttonText = '';
            let buttonClass = '';
            let isButtonDisabled = false;

            // Determine button text, class, and disabled state based on req_status
            if (val?.req_status === 'accepted') {
              buttonText = 'Finalize';
              buttonClass = 'rounded-full mt-3 f-13';
              isButtonDisabled = false;
            } else if (val?.req_status === 'finalized by customer') {
              buttonText = 'Waiting for Lawyer';
              buttonClass = 'rounded-full mt-3 f-13';
              isButtonDisabled = true;
            } else if (val?.req_status === 'finalized by customer and lawyer') {
              buttonText = 'Finalized';
              buttonClass = 'rounded-full mt-3 f-13';
              isButtonDisabled = true;
            } else if (val?.req_status === 'pending' || val?.req_status === 'rejected') {
              buttonText = val?.req_status.charAt(0).toUpperCase() + val?.req_status.slice(1);
              buttonClass = 'rounded-full mt-3 f-13 btn-disabled'; // Add custom disabled class here
              isButtonDisabled = true;
            } else if (val?.req_status === 'contract created') {
              buttonText = val?.req_status.charAt(0).toUpperCase() + val?.req_status.slice(1);
              buttonClass = 'rounded-full mt-3 f-13 btn-disabled';
              isButtonDisabled = false;
            }

            return (
              <div className="col-12 col-lg-6 col-xl-4 mb-4" key={val?.id}>
                <div className="lawyer-boxes d-flex flex-wrap">
                  <div className="lawyer-rq-icon">
                    <img
                      src={val?.lawyer_image ?? user}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = user;
                      }}
                      className="law-user-icon"
                    />
                  </div>
                  <div className="lawyer-rq-cnt">
                    <div className="d-flex justify-between align-items-center">
                      <div>
                        <h5 className="text-black mb-1">{val?.lawyer_name}</h5>
                        <p className="f-13 d-flex gap-2 align-items-center">
                          <img src={loc} className="loc-icon" />
                          {val?.lawyer_address}
                        </p>
                      </div>

                      <span className="pointer" onClick={() => handleChat(val?.lawyer_id)}>
                        <img src={agency} className="agency-info" />
                      </span>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12 col-md-5">
                        <p className="f-13">Phone Number</p>
                        <h5 className="mb-0 text-black f-14">
                          {val?.mobile_number ? val?.mobile_number : 'NA'}
                        </h5>
                      </div>
                      <div className="col-12 col-md-7">
                        <p className="f-13">Email</p>
                        <h5 className="mb-0 text-black f-14">{val?.email}</h5>
                      </div>
                    </div>
                  </div>

                  {/* Button Logic */}
                  <Button
                    className={buttonClass}
                    size="sm"
                    onClick={() => {
                      if (val?.req_status === 'accepted') handleModal(val?.lawyer?.id, val?.id);
                      else if (val?.req_status === 'contract created')
                        handleModal(val?.contract?.id, val?.contract?.contract_file);
                    }}
                    disabled={isButtonDisabled}
                  >
                    {buttonText}
                  </Button>
                </div>
              </div>
            );
          })
        ) : (
          <div className="flex flex-col items-center justify-center text-gray-500 bg-white h-80">
            <h5 className="makeCenter">Nothing to Show Yet!</h5>
          </div>
        )}
      </div>
      <div className="agency-modal">
        <Modal open={open} onClose={onCloseModal} center>
          <button
            className="modal-close-button"
            onClick={onCloseModal}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '40px',
              cursor: 'pointer',
            }}
          >
            <img src={close} className="close-circle" />
          </button>
          <section className=" agency-model">
            <h5 className="agency-title semi-bold">Contract</h5>
            <div className="conteact-modal m-0" style={{ padding: '15px' }}>
              <iframe src={link} height={100} frameborder="0"></iframe>
              <div className="signatureDiv mt-3">
                <p className="semi-bold f-18">Signature</p>
                <div className="beforeSign">
                  {signature ? (
                    <>
                      <img className="sign-preview" src={signature} alt="sasa" />
                    </>
                  ) : (
                    <>
                      <img className="signature-preview-2" src={digitalSignature} alt="sign" />
                      <span className="spanTxt">Signature will appear here</span>
                    </>
                  )}
                </div>
                {signErr && <p className="text-danger">Please add the signature</p>}
                <div className="d-flex justify-content-center  signature-contract">
                  <DigitalSignature setSignature={setSignature} />
                  <button
                    type="button"
                    className="btn btn-secondary mt-3 ml-3"
                    style={{ marginBottom: '34px' }}
                    onClick={() => setSignature(null)}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </section>
          <div className="sub-btns d-flex gap-3 mt-4 align-items-center justify-left">
            {/* <Button className="rounded-full">User Signature</Button> */}
            <Button
              className="rounded-full pink-btn"
              type="submit"
              onClick={() => handleSignature()}
            >
              Submit
            </Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default LawyerAllRequests;
